/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { errorCss, labelCss, wrapperCss } from "assets/css/fieldset.css";
import { ReactComponent as InfoIcon } from "assets/icons/InformationHeader.svg";
import { columnGap4Css } from "assets/css/gaps.css";
import Popper from "../Popper";
import { iconCss } from "./index.css";

export default function InputField({
  label,
  name,
  error,
  wrapperClassName,
  labelTextCss,
  popperText,
  children,
}) {
  return (
    <div
      css={wrapperCss}
      className={`text${wrapperClassName ? ` ${wrapperClassName}` : ""} flex-column`}
    >
      {!!label && (
        <div className="flex-a-c" css={columnGap4Css}>
          <label htmlFor={name} css={[labelCss, labelTextCss]}>
            {label}
          </label>
          {popperText && (
            <Popper text={popperText} placement="top">
              <InfoIcon css={iconCss} />
            </Popper>
          )}
        </div>
      )}

      {children}

      {!!error && <span css={errorCss}>{error}</span>}
    </div>
  );
}

InputField.propTypes = {
  name: PropTypes.string,
  labelTextCss: PropTypes.shape({}),
  wrapperClassName: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  error: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  popperText: PropTypes.string,
};
